const title = '大白健康星球'
// const securityJsCode = "7d3ae8f11a116c7a07c4ec2025371f82"

// 配置菜单的属性
const menuDefault = {
  iconDefault: 'iconfont icon-caidan',
  props: {
    label: 'name',
    path: 'path',
    icon: 'icon',
    children: 'children'
  }
}

const config = {
  development: {
    baseUrl: 'https://dbadmin.dbzdjk.com/admin'
    // baseUrl: 'http://localhost:6126/admin'
    // baseUrl: 'http://117.89.54.2:6126/admin'
    // baseUrl: 'https://dbadmin.kequbang.com/admin'
    // baseUrl: 'http://47.101.202.34:6126/admin'
    // baseUrl: 'http://192.168.20.156:6126/admin'
  },
  production: {
    baseUrl: 'https://dbadmin.dbzdjk.com/admin'
    // baseUrl: 'http://192.168.20.156:6126/admin'
    // baseUrl: 'http://localhost:6126/admin'
  },
  test: {
    baseUrl: 'http://47.101.202.34:6127/admin'
    // baseUrl: 'http://192.168.20.156:6126/admin'
    // baseUrl: 'http://localhost:6126/admin'
  }
}

const env = process.env

const baseUrl = config[env.NODE_ENV].baseUrl

const apiKey = "sk-abed386466074d3ca741b75c9ae3f46b"
// const appId = "b6777c53860443429d66ce80fffacc3c"
const appId = "34f9f8b3e8b7409ab9dd1259ebb591b6"

export {
  title,
  baseUrl,
  menuDefault,
  apiKey,
  appId
}
